import PasswordSet from './PasswordSet'
export default PasswordSet;